module.exports = __webpack_public_path__ + "img/dl (3).16f34efc.jpg";